// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function About() {
  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">JB PINTURAS</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/2829e28a7a67f99bc0d5e81b75006882.jpg"
                alt="JB Pinturas - Equipe Profissional"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-6 py-3 rounded-full font-bold shadow-lg transform rotate-12">
              <div className="text-center">
                <div className="text-sm">+ 20 ANOS</div>
                <div className="text-xs">EXPERIÊNCIA</div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">
              Mais de 20 Anos Transformando Ambientes em São José dos Campos
            </h3>
            <p className="text-gray-600 leading-relaxed">
              A <strong>JB PINTURAS</strong> é uma empresa especializada em pintura e reparos gerais, com{' '}
              <strong>mais de 20 anos de experiência</strong> atendendo o mercado de São José dos Campos e
              Vale do Paraíba.
            </p>
            <p className="text-gray-600 leading-relaxed">
              <strong>CNPJ 29.017.962/0001-35</strong> - Atuamos em todos os segmentos: pintura geral,
              texturas, pedras cristais, grafiato, granfino, reparos em gesso, reparos gerais, rejunte,
              trocas de piso quebrado e muito mais.
            </p>

            <div className="bg-orange-50 p-6 rounded-lg border-l-4 border-orange-500">
              <p className="text-orange-800 font-medium">
                🎨 <strong>Qualidade Garantida:</strong> Utilizamos apenas materiais de primeira linha e
                nossa equipe é altamente qualificada para entregar o melhor resultado.
              </p>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-yellow-500">
              <p className="text-yellow-800 font-medium">
                💼 <strong>Atendimento Personalizado:</strong> Cada projeto é único e merece atenção
                especial. Trabalhamos com dedicação para superar suas expectativas.
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
              <p className="text-green-800 font-medium">
                🛡️ <strong>Compromisso com o Cliente:</strong> Sua satisfação é nossa prioridade. Garantimos
                prazos, qualidade e o melhor custo-benefício da região.
              </p>
            </div>

            <a
              href="https://wa.me/5512981564801"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleWhatsAppClick}
              className="bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 inline-flex items-center space-x-2 whitespace-nowrap shadow-lg"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>Solicite seu Orçamento</span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-800 mb-2">Garantia de Qualidade</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Todos os serviços com garantia total
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-800 mb-2">Equipe Especializada</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Profissionais qualificados e experientes
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-paint-brush-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-800 mb-2">Materiais Premium</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Trabalhamos com as melhores marcas
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-800 mb-2">Melhor Custo-Benefício</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Preços justos e competitivos
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
